export default "__VITE_ASSET__DqH5XzoJ__"